import { useQuery } from "react-query";
import { useFaunaContext } from "../../../providers/FaunaProvider";
import { get_performance_days_by_term } from "../../../faunadb/queries/performance";

export default function usePerformanceDaysByTerm(termId) {
    const { client } = useFaunaContext();
    return useQuery(["performance-days", termId], () => get_performance_days_by_term(client, termId), { refetchOnWindowFocus: false })
}